import { Grid, Tab } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  ContratosCorreccionPara,
  EstadosContratoChoiceEnum,
  gridSizeMdLg10,
  ROUTER_PATHS,
  useLoaders,
  useTabsFormOnly,
} from '@/shared';
import {
  useUpdateAgendamiento,
  useUpdateCliente,
  useUpdateContrato,
  useUpdatePreventa,
} from '@/shared/actions/erp';
import { CustomButtunsRejectConfirm, CustomTabPanel, CustomTextArea, FormTabsOnly, TabsFormBoxScene, TabTextLabel } from '@/shared/components/ui';
import {
  Cliente,
  IContentUpdateClientFormType,
  Contrato,
  PaymentMethodEnum,
} from '@/shared/interfaces';
import {
  a11yProps,
  handleErrorForm,
} from '@/shared/utils';
import { DatosContratoCliente, DatosFormaPago, DatosFotosActualizar, DatosPersonalesCliente } from '../../../shared';
import { useUiStore } from '@/store/ui';
import { useEditPendienteActualizarFotos } from '@/erp/sale/asesor/agendamiento/shared/hook/useEditPendienteActualizarFotos';

export interface ContentUpdateClienteDataProps {
  title: string;
  contract?: Contrato;
  showRejectButton?: boolean;
  returnURLParam?: string;
  moduleDestiny?: string;
}

const ContentUpdateClienteData: React.FC<ContentUpdateClienteDataProps> = ({
  title,
  contract,
  returnURLParam = ROUTER_PATHS.ventas.agendamientoPendienteActualizacionNav,
  moduleDestiny = "VENTAS"
}) => {
  const navigate = useNavigate();
  const returnUrlClientesContratosPyLPage = returnURLParam;


  /** */
  const ultimoContenido = contract?.observaciones_contrato?.contenido?.slice(-1)[0];
  


  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  ///* Hook
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
  const { mutateAsync: mutateAsyncAgendamiento } = useUpdateAgendamiento({})

  ///* form -------------------------
  const form = useForm<IContentUpdateClientFormType>();

  const {

    formState: { errors }
  } = form


  const hookPendienteActualizar = useEditPendienteActualizarFotos({
    form
  })
  ///* effects -------------------------
  useEffect(() => {
    if (!contract) return;

    const {
      cliente_data,
      preventa_data,
      orden_trabajo_data,
      agendamiento_data,
      ...rest
    } = contract || {};

    form.reset({
      ...(preventa_data || {}),
      ...(agendamiento_data || {}),
      ...(orden_trabajo_data || {}),
      ...(cliente_data || {}),
      ...rest,
      tipo_identificacion: cliente_data?.tipo_identificacion,
      codigo_forma_pago: contract.forma_pago_data?.forma_pago,
      //
      planLabel: contract?.plan_data?.nombre || '',
      permanencia: contract?.plan_data?.permanencia || '',
      numero_contrato: contract?.numero_referencia || '',

      //* aux
      entidad_financiera: contract?.forma_pago_data?.entidad_financiera,
      url_foto_aceptacion: preventa_data?.url_foto_aceptacion,
      requiere_contrato_fisico: preventa_data?.requiere_contrato_fisico,
      es_tercera_edad: cliente_data?.es_tercera_edad,
      es_discapacidad: cliente_data?.es_discapacitado

    } as unknown as IContentUpdateClientFormType);

  }, [contract]);


  ///* mutations --------------------
  const updateContratoMutation =
    useUpdateContrato<Contrato>({
      enableAlert: false,
      enableSuccessAlert: false
    });

  const updateClienteMutation =
    useUpdateCliente<Cliente>({
      enableSuccessAlert: false
    });
  const updatePreventaMutation =
    useUpdatePreventa({
    });

  /* const { mutateAsync: updatePreventa } = useUpdatePreventa({
    enableAlert: false,
  }); */

  ///* handlers --------------------
  const onSave = async (data: any) => {
    setIsGlobalLoading(true);
    ///*Actualizar fotos
    // const imagenList = [{
    //   file: imgCedulaFrontal,
    //   url: form.getValues().url_foto_identificacion_delantera
    // },
    // {
    //   file: imgCedulaReverso,
    //   url: form.getValues().url_foto_identificacion_posterior
    // },
    // {
    //   file: imgAceptacion,
    //   url: form.getValues().url_foto_aceptacion
    // },
    // {
    //   file: imgCuentaBancaria,
    //   url: form.getValues().url_foto_cuenta_bancaria
    // },
    // {
    //   file: imgTarjeta,
    //   url: form.getValues().url_foto_tarjeta
    // },
    // {
    //   file: imgRUC,
    //   url: form.getValues().url_foto_ruc
    // },
    // {
    //   file: imgRUCNombramiento,
    //   url: form.getValues().url_foto_nombramiento
    // }
    // ];

    try {
      const listImage = await hookPendienteActualizar.handeleEditImagen()

      if (contract?.id_contrato) {

        delete data.user_create_data;
        delete data.zona_data;
        //delete data.id_preventa;
        delete data.codigo;
        delete data.preagendamiento_data
        //
        const v = form.getValues();
        const tipoFormaPago = contract?.forma_pago_data?.forma_pago;
        const formaPagoPayload =
          tipoFormaPago === PaymentMethodEnum.DEBITO
            ? {
                forma_pago: v.forma_pago,
                numero_cuenta: v.numero_cuenta,
                tipo_cuenta_bancaria: v.tipo_cuenta_bancaria,
                cooperativa: v.cooperativa || null,
                // limpiar lo de tarjeta
                tarjeta: null,
                numero_tarjeta: null,
                tarjeta_fecha_caducidad: null,
              }
            : tipoFormaPago === PaymentMethodEnum.TARJETA
            ? {
                forma_pago: v.forma_pago,
                tarjeta: v.tarjeta,
                numero_tarjeta: v.numero_tarjeta,
                tarjeta_fecha_caducidad: v.tarjeta_fecha_caducidad,
                // limpiar lo de cuenta
                numero_cuenta: null,
                tipo_cuenta_bancaria: null,
                cooperativa: null,
              }
            : { forma_pago: v.forma_pago };
        //

        await updateClienteMutation.mutateAsync({
          id: data?.id_cliente!,
          data: {
            ...form.getValues()?.cliente_data,
            razon_social: data.razon_social!,
          }
        })

        updateContratoMutation.mutateAsync({
          id: data.id_contrato,
          data: {
            direccion: data.direccion!,
            celular: data.celular,
            celular_2: data.celular_2,
            email: data.email,

            persona_referencia_parentesco: data.persona_referencia_parentesco,
            persona_referencia_nombre: data.persona_referencia_nombre,
            persona_referencia_celular: data.persona_referencia_celular,

            ///* observaciones
            observaciones: {
              ...contract.observaciones,
              observacion_asesor: form.getValues().observacion_asesor ?? 'N/A'
            },
            ///* forma de pago
            // numero_cuenta: form.getValues().numero_cuenta,
            // tipo_cuenta_bancaria: form.getValues().tipo_cuenta_bancaria,
            // numero_tarjeta: form.getValues().numero_tarjeta,
            // tarjeta_fecha_caducidad: form.getValues().tarjeta_fecha_caducidad,
            // tarjeta: form.getValues().tarjeta,
            // cooperativa: form.getValues().cooperativa,
            // forma_pago: form.getValues().forma_pago,
            ...formaPagoPayload,


            ///*
            estado_actualizacion: contract?.correccion_para == ContratosCorreccionPara.VENTAS_TECNICO ?
              EstadosContratoChoiceEnum.SOLICITUD_CORRECCION
              : EstadosContratoChoiceEnum.CORREGIDO,
            correccion_para: contract?.correccion_para == ContratosCorreccionPara.VENTAS_TECNICO ?
              ContratosCorreccionPara.TECNICO
              : null,
          } as any
        })

        ///* Actualizar preventa
        await updatePreventaMutation.mutateAsync({
          id: form.getValues().id_preventa!,
          data: {
            ...listImage,
            // numero_cuenta: form.getValues().numero_cuenta,
            // tipo_cuenta_bancaria: form.getValues().tipo_cuenta_bancaria,
            // numero_tarjeta: form.getValues().numero_tarjeta,
            // tarjeta_fecha_caducidad: form.getValues().tarjeta_fecha_caducidad,
            // tarjeta: form.getValues().tarjeta,
            // cooperativa: form.getValues().cooperativa,
            // forma_pago: form.getValues().forma_pago,
            ...formaPagoPayload,
          } as any
        })

        if (listImage) {
          //Actualizar fotos de agendamiento
          await mutateAsyncAgendamiento({
            id: form.getValues().id_agendamiento!,
            data: listImage
          })
        }

      }

      navigate(returnURLParam)

    } catch (error) {

    } finally {
      setIsGlobalLoading(false);
    }

  };

  useLoaders(updatePreventaMutation.isPending)

  return (
    <TabsFormBoxScene
      titlePage={title}
      showBtns={false}
      onCancel={() => {
        navigate(returnUrlClientesContratosPyLPage);
      }}
      pb={0}
      showCustomBtns={true}
      size={gridSizeMdLg10}
      customBtns={
        <>

          <CustomButtunsRejectConfirm
            onCancel={() => navigate(returnUrlClientesContratosPyLPage)}
            confirmTextBtn='Enviar corrección'
            onConfirm={() => {
              form.handleSubmit(onSave, err => {
                handleErrorForm(err)
              })();
            }}
            rejectTextBtn=""
            showRejectBtn={false}
            onReject={() => { }}
            sxContainer={{
              pt: 9,
            }}
          />
        </>
      }
      ///* content

      content={
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <span style={{ fontWeight: 'bold' }}>Motivo: </span>
            <>{contract?.observaciones_contrato!?.contenido?.length > 0 ?
              ultimoContenido
                ?.motivos?.filter(x => x.includes(`- ${moduleDestiny}`))?.toString()
              : contract?.motivo_rechazo_data?.nombre ?
                contract?.motivo_rechazo_data?.nombre
                : "N/A"}</>
          </Grid>
          <Grid item xs={12}>
            <span style={{ fontWeight: 'bold' }}>Observacion: </span>
            <>
              {contract?.observaciones_contrato!?.contenido?.length > 0 ?
                (ultimoContenido as any)?.migrado?
                  ultimoContenido?.observaciones
                //anterior
                :ultimoContenido?.observaciones_ventas ?
                  ultimoContenido?.observaciones_ventas
                  : ultimoContenido?.observaciones
                : contract?.observaciones?.observacion_update_cliente ?
                  contract?.observaciones?.observacion_update_cliente
                  : "N/A"}
              {/* {contract?.observaciones?.observacion_update_cliente} */}
            </>
          </Grid>
        </Grid>
      }
      // tabs
      tabs={
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="DATOS PERSONALES" value={1} {...a11yProps(1)} />
          <Tab label="CONTRATO" value={2} {...a11yProps(2)} />
          <Tab label="FORMA DE PAGO" value={3} {...a11yProps(3)} />
          <Tab label="FOTOS" value={4} {...a11yProps(4)} />
        </FormTabsOnly>
      }
    >

      {/* =================== Prospect Data =================== */}
      <CustomTabPanel index={valueTab} value={1}>
        <DatosPersonalesCliente contract={contract!} form={form} />
        {/* <p>este es uno</p> */}
      </CustomTabPanel>

      <CustomTabPanel index={valueTab} value={2}>
        <DatosContratoCliente contract={contract!} form={form} />
      </CustomTabPanel>

      <CustomTabPanel index={valueTab} value={3} justifyContent='start'>
        <DatosFormaPago contract={contract!} form={form} />
      </CustomTabPanel>

      {/* TODO: solicitud temporal pasar al componente DatosFotosActualizar */}
      <CustomTabPanel index={valueTab} value={4}>
        <DatosFotosActualizar
          {...hookPendienteActualizar}
          contract={contract!} form={form} />
      </CustomTabPanel>

      <Grid container spacing={2} marginTop={1}>


        <TabTextLabel text="Observación Asesor" />

        <CustomTextArea
          label="Observación Asesor"
          name="observacion_asesor"
          control={form.control}
          defaultValue={form.getValues().observacion_asesor || ''}
          error={errors.observacion_asesor}
          helperText={errors.observacion_asesor?.message}
          required={false}
        />
      </Grid>


    </TabsFormBoxScene>
  );
};

export default ContentUpdateClienteData;
